import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    isIntegrationsOnboardingModalOpen,
    getIntegrationsOnboardingModalPlatform,
    openIntegrationsOnboardingModal,
    closeIntegrationsOnboardingModal,
    redirectOrOpenOnboardingModal,
} from './integrations-onboarding-modal.state';

export const useIntegrationsOnboardingModal = () => {
    const dispatch = useDispatch();

    const isModalOpen = useSelector(isIntegrationsOnboardingModalOpen);
    const platform = useSelector(getIntegrationsOnboardingModalPlatform);

    const openModal = useCallback(() => {
        dispatch(openIntegrationsOnboardingModal());
    }, [dispatch]);

    const closeModal = useCallback(() => {
        dispatch(closeIntegrationsOnboardingModal());
    }, [dispatch]);

    const redirectOrOpenModal = useCallback((platformId) => {
        dispatch(redirectOrOpenOnboardingModal(platformId));
    }, [dispatch]);

    return {
        openModal,
        closeModal,
        isModalOpen,
        platform,
        redirectOrOpenModal,
    };
};
